/** Shared bits of the lobby pages' frame: where Runebound lives and the modal sheet in Poroboard's surface. */

/** runebound.gg: the home button, the account menu, deck links. */
export const RUNEBOUND_URL = 'https://runebound.gg';

/** Classes that put `Sheet` on Poroboard's FLOAT surface (the panel fill, a hairline, rounded 16). */
export const SHEET_CLASS = '!bg-[#111923] !border-[#293442] sm:!rounded-[16px]';
